<template>
  <div id="app" v-cloak>
    <router-view/>
   
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{

    }
  },
  methods:{
   
  },
}
</script>

<style>
[v-cloak] {
  display: none;
}

body{margin: 0;padding: 0}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue